import { LOADING } from "../actionType/commonType";
import { EMAIL_CONFIGURATION } from "../actionType/emailSetupType";
import {
  authenticateOutlookApiUrl,
  emailConfiguration,
  googleAuthorize,
  oauth2Google,
  outlookAuthorize,
  sendMailUrl,
} from "../constant/Constant";
import {
  deleteAuthMethod,
  formDataPostService,
  getAuthMethod,
  postAuthMethod,
} from "../services/HttpServices";

export const connectToGmail = (payload) => (dispatch) => {
  return postAuthMethod(oauth2Google, payload)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      return err;
    });
};

export const authorizeGoogle = (payload) => (dispatch) => {
  dispatch({
    type: LOADING,
    payload: true,
  });
  return getAuthMethod(`${googleAuthorize}?code=${payload}`)
    .then((res) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      return res;
    })
    .catch((err) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      return err;
    });
};

export const connectOutlook = (payload) => (dispatch) => {
  return postAuthMethod(authenticateOutlookApiUrl, payload)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      return err;
    });
};

export const authorizeOutlook = (payload) => (dispatch) => {
  dispatch({
    type: LOADING,
    payload: true,
  });
  return getAuthMethod(`${outlookAuthorize}?code=${payload}`)
    .then((res) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      return res;
    })
    .catch((err) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      return err;
    });
};

export const createEmailConfiguration = (payload) => (dispatch) => {
  return postAuthMethod(emailConfiguration, payload)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const removeEmailConfiguration = () => (dispatch) => {
  dispatch({
    type: LOADING,
    payload: true,
  });
  return deleteAuthMethod(emailConfiguration)
    .then((res) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      return res;
    })
    .catch((err) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      return err;
    });
};

export const getEmailConfiguration = () => (dispatch) => {
  dispatch({
    type: LOADING,
    payload: true,
  });
  return getAuthMethod(emailConfiguration)
    .then((res) => {
      dispatch({
        type: EMAIL_CONFIGURATION,
        payload: res.data,
      });
      dispatch({
        type: LOADING,
        payload: false,
      });
      return res.data;
    })
    .catch((err) => {
      dispatch({
        type: EMAIL_CONFIGURATION,
        payload: null,
      });
      dispatch({
        type: LOADING,
        payload: false,
      });
      return err;
    });
};

export const sendEmail = (payload) => (dispatch) => {
  return formDataPostService(sendMailUrl, payload)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};
